export const PROP_LINEUP_MODE = "PROP";

const ADMIN_LINEUP_MODES = Object.freeze([
  { value: PROP_LINEUP_MODE, label: "PROP" },
  { value: "DK_CLASSIC", label: "DraftKings NFL Classic" },
  { value: "DK_SHOWDOWN", label: "DraftKings NFL Showdown" },
]);

export function lineupModesForUser(isAdmin) {
  return isAdmin === true ? ADMIN_LINEUP_MODES : ADMIN_LINEUP_MODES.slice(0, 1);
}

export function normalizeLineupMode(value, isAdmin) {
  const requested = String(value || "").trim().toUpperCase();
  const allowed = lineupModesForUser(isAdmin).some((mode) => mode.value === requested);
  return allowed ? requested : PROP_LINEUP_MODE;
}

export function isDraftKingsLineupMode(value, isAdmin) {
  const normalized = normalizeLineupMode(value, isAdmin);
  return normalized === "DK_CLASSIC" || normalized === "DK_SHOWDOWN";
}
